var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{key:_vm.entrypoint,staticClass:"component-dist",attrs:{"id":"root"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }